/**
 * Hệ thống bệnh viện
 */

export default function Departments() {
    const selectors = {
        'wrapper' : '.js-departments',
        'form' : '.js-departments-map-form',
        'found' : '.js-found-total',
        'button' : '.js-map-toggle',
        'map' : '.js-map-view',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;

        this.display(jQuery(selectors.form));
        this.handleForm();
        this.handleScroll();
        this.handleMap();
    };

    this.template = () => {
        let compiled = null;
        compiled = _.template(
            '<div class="department-item <%= active %>">\n' +
            '<div class="department-item-wrapper py-5 border-b border-b-gray-200">\n' +
            '<div class="title text-black text-lg leading-normal uppercase font-medium mb-10px"><%= title %></div>\n' +
            '<ul class="meta flex flex-col gap-1 mb-12px">\n' +
            '<% if(address != null) { %><li class="flex items-start relative">\n' +
            '<i class="w-10px relative left-0 top-1 mr-6px"><svg fill=none height=12 viewBox="0 0 10 12"width=10 xmlns=http://www.w3.org/2000/svg><path clip-rule=evenodd d="M2.97656 5.09216C2.97656 3.95378 3.88262 3.03125 5.00067 3.03125C6.11826 3.03125 7.02418 3.95393 7.02418 5.09216C7.02418 6.22993 6.11812 7.15246 5.00067 7.15246C3.88276 7.15246 2.97656 6.23007 2.97656 5.09216ZM5.00067 4.12216C4.47436 4.12216 4.04799 4.55628 4.04799 5.09216C4.04799 5.62729 4.47421 6.06155 5.00067 6.06155C5.52639 6.06155 5.95275 5.62744 5.95275 5.09216C5.95275 4.55613 5.52625 4.12216 5.00067 4.12216Z"fill=#0B9446 fill-rule=evenodd /><path clip-rule=evenodd d="M4.99971 1.09091C2.83417 1.09091 1.07143 2.8948 1.07143 5.12927C1.07143 6.5465 1.90532 8.00107 2.90074 9.14221C3.39047 9.70364 3.8989 10.1654 4.31984 10.4824C4.53091 10.6414 4.71194 10.7579 4.85112 10.8319C4.92601 10.8717 4.97422 10.8913 4.99971 10.9008C5.02521 10.8913 5.07343 10.8717 5.14834 10.8319C5.28754 10.7579 5.4686 10.6413 5.67969 10.4824C6.10069 10.1653 6.60919 9.70362 7.099 9.14218C8.09456 8.00103 8.92857 6.54647 8.92857 5.12927C8.92857 2.89489 7.16534 1.09091 4.99971 1.09091ZM0 5.12927C0 2.30113 2.23381 0 4.99971 0C7.76552 0 10 2.30103 10 5.12927C10 6.94545 8.95841 8.65352 7.90003 9.86667C7.36287 10.4824 6.79981 10.9957 6.31682 11.3595C6.07592 11.5409 5.84687 11.6912 5.64439 11.7989C5.46792 11.8927 5.23005 12 4.99971 12C4.76936 12 4.5315 11.8927 4.35504 11.7988C4.15256 11.6911 3.92354 11.5409 3.68267 11.3594C3.19973 10.9957 2.63674 10.4824 2.09965 9.86664C1.04142 8.65349 0 6.94542 0 5.12927Z"fill=#0B9446 fill-rule=evenodd /></svg></i>\n' +
            '<span class="text-base leading-normal text-gray-600 font-normal"><%= address %></span>\n' +
            '</li><% } %>' +
            '<% if(phone != null) { %><li class="flex items-start relative">\n' +
            '<i class="w-10px relative left-0 top-1 mr-6px"><svg fill=none height=12 viewBox="0 0 12 12"width=12 xmlns=http://www.w3.org/2000/svg><path clip-rule=evenodd d="M6.99699 0.487038C7.02652 0.188212 7.27736 -0.0284788 7.55725 0.00304701C9.87207 0.263779 11.7312 2.12264 11.9961 4.51884C12.0291 4.81726 11.8292 5.08772 11.5497 5.12295C11.2702 5.15817 11.0169 4.94481 10.9839 4.6464C10.7788 2.79161 9.32668 1.29654 7.45032 1.08519C7.17043 1.05367 6.96747 0.785865 6.99699 0.487038Z"fill=#0B9446 fill-rule=evenodd /><path clip-rule=evenodd d="M7.00269 2.4806C7.05376 2.1851 7.31953 1.98976 7.5963 2.04429C8.79048 2.27955 9.74523 3.23264 9.98482 4.4801C10.0414 4.77446 9.86368 5.06202 9.58798 5.12238C9.31227 5.18274 9.04293 4.99304 8.9864 4.69868C8.8353 3.91196 8.22274 3.27423 7.41136 3.11437C7.13458 3.05985 6.95162 2.77609 7.00269 2.4806Z"fill=#0B9446 fill-rule=evenodd /><path clip-rule=evenodd d="M1.48124 1.95042C1.45482 1.9803 1.42795 2.00676 1.41475 2.01976C1.41313 2.02135 1.41172 2.02274 1.41054 2.02391L1.40896 2.02548C1.38468 2.04954 1.36237 2.07164 1.33789 2.09778C1.28919 2.14977 1.23613 2.21353 1.18735 2.2937C1.09463 2.44609 0.999941 2.68515 1.02261 3.06152C1.07018 3.85159 1.64258 5.3284 4.07922 7.79918C6.51031 10.2643 7.97626 10.8588 8.7829 10.9083C9.17275 10.9322 9.42229 10.8304 9.57886 10.7322C9.66031 10.6811 9.7242 10.6262 9.77537 10.5769C9.80111 10.552 9.82283 10.5295 9.84648 10.5049L9.84826 10.503C9.84943 10.5018 9.85081 10.5004 9.85237 10.4987C9.86536 10.4852 9.89153 10.4578 9.9209 10.4311C10.3422 10.0027 10.5701 9.7031 10.6802 9.48476C10.7788 9.28907 10.7632 9.2023 10.7436 9.1423C10.7093 9.03728 10.6126 8.8903 10.3757 8.64401C10.2627 8.52648 10.1321 8.40027 9.97941 8.25296L9.97083 8.24469C9.82253 8.10162 9.65686 7.94181 9.48165 7.76415C9.48163 7.76412 9.48168 7.76417 9.48165 7.76415C9.19871 7.47739 9.02236 7.44577 8.8986 7.44907C8.81904 7.4512 8.72842 7.46977 8.60777 7.50755C8.54752 7.52641 8.48508 7.54829 8.41368 7.57364C8.40659 7.57616 8.3994 7.57871 8.39212 7.5813C8.32855 7.60389 8.25788 7.62901 8.18562 7.65275C7.85372 7.7618 7.43148 7.86213 6.91625 7.7341C6.41016 7.60834 5.87674 7.27853 5.27251 6.66584C4.67016 6.05504 4.33791 5.50846 4.20981 4.9791C4.07833 4.43579 4.18187 3.99042 4.29058 3.64915C4.31419 3.57501 4.33917 3.50253 4.36138 3.43808C4.36392 3.4307 4.36643 3.42343 4.36889 3.41627C4.39384 3.34378 4.41501 3.28145 4.43317 3.22162C4.46963 3.10149 4.48564 3.01713 4.48743 2.94691C4.48988 2.85053 4.47203 2.68447 4.18756 2.39586C4.0103 2.21612 3.85108 2.04616 3.70881 1.8943L3.70537 1.89063C3.56011 1.73558 3.43579 1.60302 3.31994 1.48816C3.07974 1.25001 2.93073 1.14585 2.81504 1.10684C2.73276 1.0791 2.62562 1.06922 2.4228 1.17443C2.20178 1.28909 1.90382 1.52309 1.48124 1.95042ZM4.42625 1.1214C4.57021 1.27507 4.72165 1.43672 4.88944 1.60685C5.32364 2.04732 5.51852 2.49334 5.50625 2.97642C5.50068 3.19594 5.45248 3.39317 5.40273 3.55708C5.37778 3.63926 5.35034 3.71956 5.32554 3.79161C5.32305 3.79884 5.32059 3.80598 5.31816 3.81305C5.29536 3.87922 5.27481 3.93888 5.2555 3.9995C5.17343 4.25716 5.13751 4.46271 5.1966 4.70689C5.25907 4.96502 5.44742 5.34247 5.97439 5.87683C6.49949 6.40929 6.87711 6.60714 7.14729 6.67427C7.40832 6.73914 7.62755 6.6976 7.88584 6.61273C7.94636 6.59285 8.00587 6.57171 8.07096 6.54858C8.07795 6.5461 8.08499 6.54359 8.09211 6.54107C8.16316 6.51585 8.24126 6.48833 8.32095 6.46337C8.48019 6.41351 8.66708 6.36677 8.87308 6.36126C9.32043 6.3493 9.7474 6.53308 10.1835 6.97506C10.3494 7.14332 10.5071 7.29548 10.6571 7.44012L10.6627 7.44558C10.8121 7.58972 10.9576 7.73009 11.0868 7.8645C11.3345 8.12208 11.5873 8.42044 11.706 8.78422C11.8395 9.19302 11.7803 9.59851 11.5776 10.0005C11.3874 10.3778 11.0594 10.7776 10.6102 11.233C10.6008 11.2424 10.5912 11.2515 10.5812 11.2602C10.5787 11.2627 10.5719 11.2695 10.559 11.2829L10.5551 11.287C10.5323 11.3107 10.4987 11.3456 10.4586 11.3843C10.372 11.4678 10.2522 11.572 10.0949 11.6706C9.77393 11.8718 9.32566 12.0316 8.72438 11.9947C7.54877 11.9225 5.85924 11.1049 3.37734 8.58819C0.900367 6.07651 0.0790364 4.35238 0.00550604 3.13134C-0.032383 2.50216 0.130528 2.03313 0.332657 1.70092C0.4313 1.5388 0.534978 1.41613 0.617211 1.32833C0.655461 1.2875 0.68998 1.25331 0.713303 1.23021C0.714649 1.22888 0.715957 1.22758 0.717226 1.22632C0.73038 1.21329 0.737129 1.20639 0.73968 1.20381C0.748329 1.1936 0.757339 1.18374 0.766692 1.17425C1.21788 0.716583 1.61073 0.3859 1.97738 0.195696C2.36441 -0.00508136 2.74245 -0.0587614 3.12197 0.0691999C3.46806 0.185893 3.75744 0.436937 4.01349 0.690794C4.14499 0.82118 4.28243 0.967879 4.42351 1.11848L4.42625 1.1214Z"fill=#0B9446 fill-rule=evenodd /></svg></i>\n' +
            '<span class="text-base leading-normal text-gray-600 font-normal"><a href="tel:<%= phone %>"><%= phone %></a></span>\n' +
            '</li><% } %>' +
            '</ul>\n' +
            '<div class="action">\n' +
            '<button type="button" data-map_url="<%= embed_url %>" class="border border-primary rounded-40px px-4 py-6px bg-white hover:bg-button-hover text-primary text-base leading-tight font-medium duration-400 transition-colors js-map-toggle">Chỉ đường</button>\n' +
            '</div>\n' +
            '</div>\n' +
            '</div>');

        return compiled;
    }

    this.getDepartments = async (search, city, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + 'departments',
            data : {
                q: search,
                city: city,
                paged: paged,
            },
            context: this
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })
    }

    this.handleScroll = () => {
        let resultsDom = jQuery(selectors.wrapper).find('.found-results');
        resultsDom.on('scroll', (e) => {
            const element = e.currentTarget;
            if (jQuery(element).scrollTop() + jQuery(element).innerHeight() >= element.scrollHeight) {
                let $form = jQuery(selectors.form);
                let current_page = parseInt($form.find('[name="paged"]').val())
                let total_pages = parseInt($form.find('[name="total_pages"]').val())
                if (current_page < total_pages) {
                    $form.find('[name="paged"]').val(current_page+1)
                    this.display($form, true);
                }
            }
        });
    }

    this.handleMap = () => {
        jQuery(selectors.wrapper).on('click', selectors.button, async (e) => {
            e.preventDefault();
            let $this = jQuery(e.target);
            let $wrapper = $this.closest('.department-item');
            let map_url = $this.data("map_url");

            jQuery(selectors.map).html(this.mapHtml(map_url));

            $wrapper.addClass('active').siblings().removeClass('active')

            if (jQuery(window).width() <= 768) {
                let headerHeight = jQuery('#header').outerHeight();
                jQuery('html, body').animate({
                    scrollTop: jQuery(selectors.map).offset().top - headerHeight
                }, 1000);
            }
        })
    }

    this.mapHtml = (url) => {
        return `<iframe src="${url}" width="600" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>`
    }

    this.display = async ($form, append = false) => {
        let search = $form.find('[name="search"]').val();
        let city = $form.find('[name="city"]').val();
        let paged = parseInt($form.find('[name="paged"]').val());

        await this.getDepartments(search, city, paged).then( (res) => {
            if (res.data) {
                let itemTemplate = this.template();
                let resultsDom = jQuery(selectors.wrapper).find('.found-results');
                if (!append) {
                    resultsDom.empty();
                }

                let map_url = null;
                let first = false;
                for(let i in res.data) {
                    let item_data = res.data[i];
                    item_data.active = '';
                    if (!append && !first) {
                        map_url = item_data.embed_url;
                        item_data.active = 'active';
                        first = true;
                    }

                    resultsDom.append(itemTemplate(item_data));
                }

                if (!append && map_url) {
                    jQuery(selectors.map).html(this.mapHtml(map_url));
                }
            }

            if (res.meta) {
                jQuery(selectors.found).text(res.meta.total)
                $form.find('[name="paged"]').val(res.meta.current_page)
                $form.find('[name="total_pages"]').val(res.meta.total_pages)
            }
        })
    }
}
